import { TherapyJobV2 } from '../models/TherapyJobV2';

export const flowRateDifference = (tj: Partial<TherapyJobV2>): number => {
  const planned = tj?.flowRatePlannedEdited || tj?.flowRatePlannedPrescribed || 0;
  const actual = tj?.therapyJobProgress?.currentFlowRate || 0;

  if (planned === 0) {
    return 0;
  }

  return actual - planned;
};
